import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { Page } from 'page/Page/Page'
import { EmailStep } from 'page/ProfileScreen/Email/EmailStep'
import { SelfieHelpStep } from 'page/ProfileScreen/HelpStep/SelfieHelpStep'
import { ProfileDeleteModal } from 'page/ProfileScreen/ProfileDeleteModal/ProfileDeleteModal'
import { profileDeleteModal } from 'page/ProfileScreen/ProfileDeleteModal/ProfileDeleteModalStore'
import { SizesStep } from 'page/ProfileScreen/SizesStep/SizesStep'
import { UploadQrModal } from 'page/ProfileScreen/UploadQrModal/UploadQrModal'
import { uploadQrModal } from 'page/ProfileScreen/UploadQrModal/UploadQrModalStore'
import { BasicView } from 'page/ProfileScreen/view/BasicView'
import { PhotoView } from 'page/ProfileScreen/view/PhotoView'
import { RegularView } from 'page/ProfileScreen/view/RegularView'
import { StandView } from 'page/ProfileScreen/view/StandView'
import { controller } from 'store/controller'
import { opt } from 'store/opt'
import { store } from 'store/store'
import { Padding } from 'util/style'

export const SelfieProfilePage = observer(() => {
  const { step } = store.profile
  const pad: Padding = opt.stand2 ? [0, 24] : [16, 16, 0, 16]

  const onBack = useLatestCallback(() => {
    controller.closeProfile()
  })

  const hasNoProfiles = store.identities.profiles.length === 0
  const hasOnlyEmptyProfileAfterDelete =
    store.identities.profiles.length === 1 &&
    !store.profile.identity_id &&
    !store.profile.hasSelfie &&
    !store.profile.common.userPhoto.url

  const profileHasAnyData =
    store.profile.hasSelfie ||
    store.profile.common.userPhoto.url ||
    store.profile.common.userPhoto.src

  const showProfileOptions =
    (hasNoProfiles || hasOnlyEmptyProfileAfterDelete) &&
    opt.photo.length > 1 &&
    !profileHasAnyData &&
    !store.profile.isNew

  return (
    <Page pad={pad} long onBack={onBack}>
      <Vertical center minWidth={320}>
        <Vertical wide maxWidth="var(--max-width)" minHeight="var(--page-viewport-height-simple)">
          {opt.basic ? <BasicView /> : showProfileOptions ? <PhotoView /> :
            opt.stand2 ? <StandView /> : <RegularView />}

          {profileDeleteModal.present && <ProfileDeleteModal />}
          {uploadQrModal.present && <UploadQrModal />}

          {step === 'email' && <EmailStep />}
          {step === 'help' && <SelfieHelpStep />}
          {step === 'sizes' && <SizesStep />}
        </Vertical>
      </Vertical>
    </Page>
  )
})
